import { Navigate, type RouteObject } from "react-router";

import { Layout } from "@/Layout";
import { Account } from "@/components/Account";
import { AllDecks } from "@/components/AllDecks";
import { Deck } from "@/components/Deck";
import { ErrorMessage } from "@/components/ErrorMessage";
import { Review } from "@/components/Review/Review";
import { GenerateDeck } from "@/components/GenerateDeck";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorMessage title="Oops!" message="Something went wrong." />,
    children: [
      {
        index: true,
        element: <Navigate to="/decks" replace />,
      },
      {
        path: "decks",
        element: <AllDecks />,
        handle: {
          headerDisplayName: "My Decks",
        },
      },
      {
        path: "decks/:deckId",
        element: <Deck />,
        handle: {
          headerDisplayName: "My Decks",
        },
      },
      {
        path: "account",
        element: <Account />,
        handle: {
          headerDisplayName: "My Account",
        },
      },
      {
        path: "generate",
        element: <GenerateDeck />,
        handle: {
          headerDisplayName: "My Decks",
        },
      },
    ],
  },
  {
    path: "review",
    element: <Review mode="scheduled" />,
    errorElement: (
      <ErrorMessage title="Error loading reviews" message="Something went wrong loading reviews." />
    ),
  },
  {
    path: "review/:deckId",
    element: <Review mode="scheduled" />,
    errorElement: (
      <ErrorMessage
        title="Error loading reviews"
        message="The deck you want to review does not exist."
      />
    ),
  },
  {
    path: "review-all/:deckId",
    element: <Review mode="all" />,
    errorElement: (
      <ErrorMessage
        title="Error loading reviews"
        message="The deck you want to review does not exist."
      />
    ),
  },
  {
    path: "review-missed/:deckId",
    element: <Review mode="missed" />,
    errorElement: (
      <ErrorMessage
        title="Error loading reviews"
        message="The deck you want to review does not exist."
      />
    ),
  },
] satisfies RouteObject[];
